// Shared utility for uploading files with extra fields and authorization
export async function uploadFileGeneric({
  file,
  uploadUrl,
  uploadBody,
  token,
}: {
  file: File,
  uploadUrl: string,
  uploadBody?: Record<string, unknown>,
  token?: string,
}): Promise<string> {
  // Create form data
  const formData = new FormData();
  formData.append('file', file);
  
  // Add additional fields
  if (uploadBody) {
    Object.entries(uploadBody).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, String(value));
      }
    });
  }
  
  try {
    const response = await fetch(uploadUrl, {
      method: 'POST',
      body: formData,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    
    if (!response.ok) {
      console.error('❌ Upload failed:', response.status, response.statusText);
      throw new Error(`File upload failed: ${response.statusText}`);
    }
    
    const responseText = await response.text();

    return responseText;
  } catch (error) {
    console.error('❌ Upload error:', error);
    throw error;
  }
}
